import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "checked-icon"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]

import { IonLabel, IonPage, IonRouterOutlet, IonTabBar, IonTabButton, IonTabs } from "@ionic/vue";
import { ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import clickedHomeTab from "@/assets/teacher_index/version5/clicked_home_tab.svg";
import homeTab from "@/assets/teacher_index/version5/home_tab.svg";
import clickedRecordTab from "@/assets/teacher_index/version5/clicked_record_tab.svg";
import recordTab from "@/assets/teacher_index/version5/record_tab.svg";
import clickedStudentTab from "@/assets/teacher_index/version5/clicked_student_tab.svg";
import studentTab from "@/assets/teacher_index/version5/student_tab.svg";
import clickedUserTab from "@/assets/teacher_index/version5/clicked_user_tab.svg";
import userTab from "@/assets/teacher_index/version5/user_tab.svg";
import { checkUserType } from "@/js/message";


export default /*@__PURE__*/_defineComponent({
  __name: 'TeacherTabs',
  setup(__props) {

const currentIndex = ref(0);
const router = useRouter();
const route = useRoute();
const pathList = ["/TeacherIndex", "/ClassRecord", "/StudentList", "/TeacherPersonalIndex"];
const tabList = [
  { label: "首页", icon: homeTab, clickedIcon: clickedHomeTab },
  { label: "训练记录", icon: recordTab, clickedIcon: clickedRecordTab },
  { label: "学员信息", icon: studentTab, clickedIcon: clickedStudentTab },
  { label: "个人中心", icon: userTab, clickedIcon: clickedUserTab },
];

function changeBtn(type: number) {
  if (checkUserType()) return
  currentIndex.value = type
  router.replace(pathList[type]);
}

watch(
    () => route.path,
    (newVal) => {
      currentIndex.value = pathList.indexOf(newVal);
    },
    { deep: true, immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonTabs), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonRouterOutlet)),
          _createVNode(_unref(IonTabBar), {
            slot: "bottom",
            class: "bottom-tabbar"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabList, (i, idx) => {
                return _createVNode(_unref(IonTabButton), {
                  key: idx,
                  class: _normalizeClass({ 'active-class': currentIndex.value === idx }),
                  tab: "tab1",
                  onClick: ($event: any) => (changeBtn(idx))
                }, {
                  default: _withCtx(() => [
                    (currentIndex.value === idx)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                          _createElementVNode("img", {
                            class: "pic",
                            src: i.clickedIcon,
                            alt: ""
                          }, null, 8, _hoisted_2)
                        ]))
                      : (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          class: "pic",
                          src: i.icon,
                          alt: ""
                        }, null, 8, _hoisted_3)),
                    _createVNode(_unref(IonLabel), { class: "label" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(i.label), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["class", "onClick"])
              }), 64))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})